module.exports = __webpack_public_path__ + "static/uninstall_1-21591ca6ec8dff463fd54a57ffdb98a5.png";